<template>
  <div class="row">
    <div class="row-header">
        
        <div class="product-image">
            <router-link tag="a" :to="{name: 'blog', params: {slug: blog.slug}}">
                <img class="bordered-image row-image" :src="'/images/blogs/' + blog.mainimage" :alt="blog.title">
            </router-link>
        </div>
        <div class="product-info block-with-vsmall-vertical-gap">
            <router-link tag="a" :to="{name: 'blog', params: {slug: blog.slug}}">
                <h5 class="title is-4 small-gap-bottom">
                    {{ blog.title }}
                </h5>
            </router-link>
            <p class="subtitle is-6">by {{ blog.author }}</p>
            <p v-html="truncatedBlurbLong(blog.body)" />
        </div>
    </div>
    
    <!-- <router-link tag="a" class="button" :to="{ name: 'product', params: { slug: blog.slug }}">Description</router-link>
    <button class="button is-primary" @click="addToCart(blog)">Buy Now</button> -->
  </div>
</template>

<script>
//import mixins from '@/mixins/mixins';
// import Api from '@/config/Api'; // MCH added

// import AlertMeButton from './AlertMeButton';
// import MaxPriceWidget from './MaxPriceWidget';

export default {
    props: ['blog'],
    /* components: {
        ProductShopRows,
        ProductEventRows,
        AlertMeButton,
        MaxPriceWidget
    }, */
    //mixins: [mixins],
    methods: {
        truncatedBlurb(blurb) {
            if (!blurb) return;
            var output = this.$options.filters.truncate(blurb, 150)
            // | truncate(160, '...')
            return output;
        },
        truncatedBlurbLong(blurb) {
            if (!blurb) return;
            var output = this.$options.filters.truncate(blurb, 600)
            // | truncate(160, '...')
            return output;
        }
    }


}
</script>

<style scoped>
.small-gap-bottom {
    margin-bottom: 0.3em;
}
/* img.row-image {
  height: auto;
  width: 100%;
  max-width: 600px;
} */
.row {
  margin-bottom: 2em;
}
.row-header {
  /* background: #eee; */
}
.product-image {
  vertical-align: top;
  display: inline-block;
}
.product-info {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/cards/BlogRow.vue